import book from './book.vue'
import Vue2TouchEvents from 'vue2-touch-events'

book.install = function (Vue) {
  // Custom directives
  Vue.directive('visible', function(el, binding) {
    // el.style.visibility = !!binding.value ? 'visible' : 'hidden';
    // el.style.opacity = !!binding.value ? '1' : '0';
    if (!!binding.value) {
      el.style.opacity = '1'
      el.classList.add("visible")
    } else {
      el.style.opacity = '0'
      el.classList.remove("visible")
    }
  });

  // Touch event support for mobile devices
  Vue.use(Vue2TouchEvents)

  // Register the component
  Vue.component(book.name, book)
}

export default book



//////////////////
// WEBPACK FOOTER
// ./~/vue-book-component/components/book/index.js
// module id = 4
// module chunks = 0